<template>
  <div class="contato">
    <div class="container">
      <h1 class="display-1 mt-3">Fale Conosco</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-3">
        <v-flex xs12 md6 lg4 class="mb-4">
          <p class="headline mt-4">Paço Municipal</p>
          <p class>
            <span class="title">Endereço:</span> Av. do Cerrado, n° 999 - Park Lozandes, Goiânia-GO
          </p>
          <p class>
            <span class="title">Horário de Funcionamento:</span>Segunda à Sexta das 8h às 17h
          </p>
          <p class>
            <span class="title">Telefone:</span> (62) 3524-1000
          </p>

          <!-- <iframe
            src="https://dsfnet.movidesk.com/form/2487/"
            height="960"
            width="100%"
            frameborder="0"
            scrolling="auto"
          ></iframe>-->
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md6></v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {};
</script>


